import { createSelector } from 'reselect'
import confirmTypes from 'helpers/enums/confirmTypes'
import viewTypes from 'helpers/enums/viewTypes'
import loginErrorCodes from 'helpers/enums/loginErrorCodes'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import libraryTypes from 'helpers/enums/libraryTypes'

const confirmSelectorState = state => state.confirm
const qsSelectorState = state => state.qs
const userShownModalsState = state => state.user.shownModals
const currentView = state => state.ui.currentView
const userNotificationMessage = state => state.user.data ? state.user.data.notificationMessage : null
const gameSelector = state => state.game.confirms
const getLtiData = state => state.lti
const myLibraryData = state => state.myLibrary
const interactiveVideoCreationSelector = state => state.interactiveVideoCreation.confirms
const drawItSelector = state => state.drawIt.confirms
const matchingPairsSelector = state => state.matchingPairsCt.confirms

const validLoginErrors = [loginErrorCodes.LOGIN_SSO_ERROR_MESSAGE_LTI, loginErrorCodes.LOGIN_SIGNUP_ERROR_MESSAGE_LTI]
const confirmSelector = createSelector(
	[
		confirmSelectorState,
		qsSelectorState,
		userShownModalsState,
		userNotificationMessage,
		currentView,
		gameSelector,
		getLtiData,
		myLibraryData,
		interactiveVideoCreationSelector,
		drawItSelector,
		matchingPairsSelector,
	],
	(
		confirmSelectorData,
		qsSelectorData,
		userShownModalsData,
		userNotificationMessageData,
		currentViewData,
		gameConfirms,
		ltiData,
		myLibraryData,
		interactiveVideoCreationConfirms,
		drawItConfirms,
		matchingPairsConfirms,
	) => {
		let confirmType = ''
		let confirmProps = {}

		if (confirmSelectorData.length) {
			const confirmModalData = confirmSelectorData[0]
			confirmType = confirmModalData.confirmType
			confirmProps = confirmModalData.confirmProps

		} else if (!userShownModalsData.lms && qsSelectorData.referer &&
					qsSelectorData.referer.search('ltiUid') !== -1) {
			confirmType = confirmTypes.LOGIN_INITIALIZE

		} else if (!userShownModalsData.sso && validLoginErrors.includes(qsSelectorData.lerr)) {
			confirmType = confirmTypes.LOGIN_SSO_ERROR
		} else if (userNotificationMessageData &&
			userNotificationMessageData.showMessage === '1' &&
			userNotificationMessageData.overlayType &&
			(userNotificationMessageData.showIn.includes('all') || userNotificationMessageData.showIn.includes(currentViewData))) {
			confirmType = userNotificationMessageData.overlayType
		} else if (gameConfirms.length) {
			confirmType = gameConfirms[0].type
			confirmProps = gameConfirms[0].props
		} else if (
			formatLibraryType(ltiData) !== libraryTypes.REGULAR
			&& !myLibraryData.folders.some(folder => folder.presentationsCount)
			&& !myLibraryData.lessons.length
			&& myLibraryData.input_value === ''
			&& myLibraryData.current.search.page === 1
			&& !myLibraryData.confirmsVisited.includes(confirmTypes.MY_LIBRARY_NO_LESSONS_LTI_CONFIRM)) {
			confirmType = confirmTypes.MY_LIBRARY_NO_LESSONS_LTI_CONFIRM
		} else if (interactiveVideoCreationConfirms.length) {
			confirmType = interactiveVideoCreationConfirms[0].type
			confirmProps = interactiveVideoCreationConfirms[0].props
		} else if (myLibraryData.confirms.length) {
			confirmType = myLibraryData.confirms[0].type
			confirmProps = myLibraryData.confirms[0].props
		} else if (drawItConfirms.length) {
			confirmType = drawItConfirms[0].type
			confirmProps = drawItConfirms[0].props
		} else if (matchingPairsConfirms.length) {
			confirmType = matchingPairsConfirms[0].type
			confirmProps = matchingPairsConfirms[0].props
		}

		//Handling of confirms that are hidden on the Google Classroom Extension
		if (
			ltiData.extension === '1'
			&& !(
				confirmSelectorData.length
				&& confirmSelectorData[0].confirmType === confirmTypes.MY_LIBRARY_PREMIUM_FEATURE_UPGRADE
			)
		) {
			confirmType = ''
			confirmProps = {}
		}

		//Handling of confirms that are hidden on the Google Slides Add-On
		if (currentViewData === viewTypes.GOOGLE_SLIDES_SIDEBAR) {
			confirmType = ''
			confirmProps = {}
		}

		return {
			confirmType,
			confirmProps,
		}
	}
)

export default confirmSelector
